const getStructuredDataProperties = isFaqContent => {
  const properties = {
    topWrapperProps: {},
    groupSectionProps: {},
    groupSectionTitleProps: {},
    groupContentWrapperProps: {},
    groupContentProps: {}
  };
  if (!isFaqContent) return properties;

  properties.topWrapperProps = {
    itemScope: true,
    itemType: 'https://schema.org/FAQPage'
  };
  properties.groupSectionProps = {
    itemScope: true,
    itemProp: 'mainEntity',
    itemType: 'https://schema.org/Question'
  };
  properties.groupSectionTitleProps = {
    itemProp: 'name'
  };
  properties.groupContentWrapperProps = {
    itemScope: true,
    itemProp: 'acceptedAnswer',
    itemType: 'https://schema.org/Answer'
  };

  properties.groupContentProps = {
    itemProp: 'text'
  };

  return properties;
};

export default getStructuredDataProperties;
